const euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

/** Cents as euro, e.g. "6,50 €". */
export function formatEuro(cents: number): string {
  return euro.format(cents / 100);
}
